/* eslint-disable indent */

/*
 Search summary, displays in the result page a brief info of the flight data of the search. For example
 Madrid to London, Barcelona, Paris | Wed 4 Jul - Thu 13 Aug | 5 p

 Created on       : 20-08-2013, 11:14:30
 Author           : Enrique Torres, Manuel Diez
 Widget type      : Widget
 Required params:

 */
    'use strict';
    Odigeo.defineWidget('searchsummary', Odigeo.Widget.extend({
        trackingUtils: require('../modules/utils/tracking.utils'),

        isExpanded: false,

        // Flag to avoid the toggleView of the panel if it is clicked while is animating
        animating: false,

        modelClass: Odigeo.Model.extend({

            getData: function() {
                return Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters'));
            },

        }),

        viewClass: Odigeo.View.extend({

            init: function() {
                this.cacheDomSelectors();
                this.bindToDom();
            },

            // save DOM selectors to the widget cache
            cacheDomSelectors: function() {
                this.addSelectorToCache('widgetWrapper', this.$widget.find('.od-searchSummary-wrapper'));
                this.addSelectorToCache('summaryDataFlights', this.$widget.find('.summary_data_flights_labels'));
                this.addSelectorToCache('summaryTemplate', this.$widget.find('.summary_template'));
                this.addSelectorToCache('summaryChangeSearch', this.$widget.find('.collapsed_summary_link'));
                this.addSelectorToCache('content', this.$widget.find('.collapsed_summary'));
                this.addSelectorToCache('summaryPax', this.$widget.find('.search_summary_passengers'));
                this.addSelectorToCache('editHeaderButton', this.$widget.find('.edit_header_button'));
                this.addSelectorToCache('detailsHeaderWrapper', this.$widget.find('.details_header_wrapper'));
            },

            updateView: function(html) {
                this.$cachedSelectors['summaryDataFlights'].empty().append(html);
                this.removeSelectorFromCache('summaryPax');
                this.addSelectorToCache('summaryPax', this.$widget.find('.search_summary_passengers'));
            },

            updatePassengers: function(flightsData) {
                var passengers = {
                    adults: {
                        num: flightsData.numAdults,
                        key: this.$cachedSelectors.summaryPax.data('adult-plural'),
                    },
                    children: {
                        num: flightsData.numChildren,
                        key: this.$cachedSelectors.summaryPax.data('child-plural'),
                    },
                    infants: {
                        num: flightsData.numInfants,
                        key: this.$cachedSelectors.summaryPax.data('infant-plural'),
                    },
                };
                var $summarySearchPassengers = this.$cachedSelectors['summaryDataFlights'].find('.od-searchSummary-passengers');
                var passengerTexts = Odigeo._.chain(passengers)
                    .map(function(item) {
                        if (item.num === 0) {
                            return false;
                        }
                        return Odigeo.Utils.pluralizeAll(item.key, item.num);
                    }, {$el: $summarySearchPassengers})
                    .compact()
                    .value();
                var totalTravellers = flightsData.numAdults + flightsData.numChildren + flightsData.numInfants;
                var hasApplyTravellersText = flightsData.numAdults > 2 || (flightsData.numChildren > 0 || flightsData.numInfants > 0);

                var travellersText = Odigeo.Utils.pluralizeAll(this.$cachedSelectors.summaryPax.data('traveller-plural'),
                    totalTravellers);

                $summarySearchPassengers.html(hasApplyTravellersText ? travellersText : passengerTexts.join(', '));
            },

            bindToDom: function() {
                this.$cachedSelectors.summaryChangeSearch.on(Odigeo.Events.tap, Odigeo._.bind(this.toggleChangeSearch, this, 'summaryChangeSearch'));
                this.$cachedSelectors.summaryDataFlights.on(Odigeo.Events.tap, Odigeo._.bind(this.toggleChangeSearch, this, 'summaryDataFlights'));
                this.$cachedSelectors.detailsHeaderWrapper.on(Odigeo.Events.tap, Odigeo._.bind(this.onClickDetails, this));
            },

            toggleChangeSearch: function(origin) {
                var label = 'open_change_search';
                var action = 'searcher_flights';

                if (origin === 'summaryChangeSearch' && Odigeo.SessionScope.flow !== 'mobile') {
                    label = 'click_trip_information';
                } else if (this.widget.id !== 'results-search-summary') {
                    action = 'header';
                    label = 'click_trip_information';
                }

                if (this.widget.options.isDynpack) {
                    this.widget.trackingUtils.trackEvent('searcher_dynpack', 'click_change_search');
                } else {
                    const page = this.widget.options.isWaitingPage ? 'waiting_1' : '';
                    this.widget.trackingUtils.trackEvent(action, label, page);
                }

                if (this.widget.options.isInDetailsPage === true) {
                    Odigeo.Router.navigate('results');
                } else {
                    Odigeo.trigger(this.widget.id + ':toggleChangeSearch');
                }
                Odigeo.trigger('results-remove-filters:showFilterBox', false);
            },

            onClickDetails: function() {
                const showTouchpoint = !window.location.hash.includes('no_results');
                Odigeo.trigger('searchsummary:clickDetails', showTouchpoint);
            },

            showContent: function() {
                this.$cachedSelectors.content.removeClass('hidden');
            },
            hideContent: function() {
                this.$cachedSelectors.content.addClass('hidden');
            },
            showInDetailsPage: function() {
                this.$cachedSelectors.widgetWrapper.addClass('od-show-detail-search-summary');
                Odigeo.trigger(this.widget.id + ':showHeaderBackgroundSearchSummary');
            },

            toggleEditHeaderButtonHidden: function(hide) {
                this.$cachedSelectors.editHeaderButton.toggleClass('odf-hidden', hide);
            },
            removeWaitingFlag() {
                this.widget.options.isWaitingPage = false;
            },
            showDetailsInWaiting() {
                const updateDetailsDisplay = Odigeo.SessionScope.flow === 'mobile' && !Odigeo.Utils.isRequestApp('dp');
                const isMobileResults2Batches = Odigeo.AB.isMobileResults2Batches && !Odigeo.SessionScope.marketingPortalIsMeta;
                this.updateDetailsButtonDisplay(!updateDetailsDisplay && !isMobileResults2Batches);
                this.showContent();
                this.widget.options.isWaitingPage = true;
            },
            updateDetailsButtonDisplay: function(shallHide) {
                const hideFlightInfoPageButton = shallHide ||
                    (Odigeo.Session.storage.page === 'payment' && Odigeo.SessionScope.flow === 'mobile');
                this.$cachedSelectors.summaryChangeSearch.toggleClass('odf-hidden', hideFlightInfoPageButton);
                if (hideFlightInfoPageButton ) {
                    this.$cachedSelectors.detailsHeaderWrapper.off(Odigeo.Events.tap);
                } else {
                    this.$cachedSelectors.detailsHeaderWrapper.on(Odigeo.Events.tap, Odigeo._.bind(this.onClickDetails, this));
                }
            },
        }),

        init: function() {
            Odigeo._.templateSettings = {
                evaluate: /\{\{#(.+?)\}\}/g,
                interpolate: /\{\{([^#].*?)\}\}/g,
            };
            this.options = Odigeo.parseOptions(this.options);
            this.template = Odigeo._.template(this.view.$cachedSelectors['summaryTemplate'].html());
            this.refresh();
            if (this.options.isInDetailsPage && !Odigeo.Session.get('changeSearchMetaShown')) {
                Odigeo.Session.set('changeSearchMetaShown', true);
                this.view.showInDetailsPage();
            }
        },

        refresh: function() {
            var flightsData = this.options.loadFlightInfoFromSession ? this.model.getData() : this.options;
            var template;
            if (!Odigeo._.isNull(flightsData)) {
                template = this.constructTemplate(flightsData);

                this.view.updateView(template);
                this.view.updatePassengers(flightsData);
            }
        },

        getOneLegData: function(data) {
            var destinationCity = data.destinationCity;
            var destinationIata = data.destinationIata;

            return {
                origin: data.origin,
                destination: data.destination,
                originIata: data.originIata,
                destinationIata: destinationIata,
                originCity: data.originCity,
                destinationCity: destinationCity,
            };
        },

        getMultiTripLegData: function(searchSegments, showMultiDestinationWithData) {
            var auxiliarDestination = null;
            var multiDestinationAttribute = showMultiDestinationWithData ? 'iata' : 'name';

            return Odigeo._.map(searchSegments, function(segment) {
                var currentDestination = segment.destination[multiDestinationAttribute];
                var currentOrigin = segment.departure[multiDestinationAttribute];
                var sameAirport = auxiliarDestination === currentOrigin;
                auxiliarDestination = currentDestination;
                return {
                    origin: currentOrigin,
                    destination: currentDestination,
                    originIata: segment.departure.iata,
                    repeat_air: sameAirport,
                    destinationIata: segment.destination.iata,
                    originCity: (!Odigeo._.isNull(segment.departure.city)) ? segment.departure.city : segment.departure.name,
                    destinationCity: segment.destination.city || segment.destination.name,
                };
            });
        },
        getDetailedLegData: function(flightsData) {
            return Odigeo._.map(flightsData.searchSegments, function(segment, legIndex) {
                return {
                    originIata: segment.departure.iata,
                    destinationIata: segment.destination.iata,
                    date: Odigeo.Utils.parseDate(segment.dateStr),
                    legIndex: legIndex,
                    type: flightsData.type,
                };
            });
        },
        constructTemplate: function(flightsData) {
            if (Odigeo._.isEmpty(flightsData) || !flightsData.searchSegments.length) {
                return false;
            }
            var cityLabelsInIata = (flightsData.searchSegments[0].departure.name && flightsData.searchSegments[0].departure.name.length > 14) ||
                (flightsData.searchSegments[0].destination.name && flightsData.searchSegments[0].destination.name.length > 14);
            var constructorInfo = {
                passengers: flightsData.numAdults + flightsData.numChildren + flightsData.numInfants,
                type: flightsData.type,
                toLabel: this.options.to,
                origin: (cityLabelsInIata) ? flightsData.searchSegments[0].departure.iata : flightsData.searchSegments[0].departure.name,
                destination: (cityLabelsInIata) ?
                    flightsData.searchSegments[0].destination.iata : flightsData.searchSegments[0].destination.name,
                originCity: flightsData.searchSegments[0].departure.city || flightsData.searchSegments[0].departure.name,
                destinationCity: flightsData.searchSegments[0].destination.city || flightsData.searchSegments[0].destination.name,
                originIata: flightsData.searchSegments[0].departure.iata,
                destinationIata: flightsData.searchSegments[0].destination.iata,
                flexibleDates: flightsData.flexibleDates,
            };
            var legs;
            var numSegments;
            var dates;
            var differenceInDays;

            if (this.options.showDetailedItineraryInfo) {
                legs = this.getDetailedLegData(flightsData);
            } else {
                switch (flightsData.type) {
                    // Summary for OneWayTrip
                    case 'oneWayTrip':
                        legs = [this.getOneLegData(constructorInfo)];
                        dates = [Odigeo.Utils.parseDate(flightsData.searchSegments[0].dateStr)];
                        break;
                    // Summary for RoundTrip
                    case 'roundTrip':
                        legs = [this.getOneLegData(constructorInfo)];
                        dates = [Odigeo.Utils.parseDate(flightsData.searchSegments[0].dateStr),
                            Odigeo.Utils.parseDate(flightsData.searchSegments[1].dateStr)];
                        differenceInDays = Odigeo.Utils.getDifferenceInDays(dates[0], dates[1]);
                        break;
                    // Summary for MultipleTrip
                    case 'multipleTrip':
                        // Obtain number of flights in multiple flights
                        numSegments = flightsData.searchSegments.length;
                        legs = this.getMultiTripLegData(flightsData.searchSegments, this.options.show_multiple_destination_with_iata);
                        if (!Odigeo._.isUndefined(this.options.wantAllDates) && this.options.wantAllDates) {
                            dates = [];
                            Odigeo._.each(flightsData.searchSegments, function(segment) {
                                dates.push(Odigeo.Utils.parseDate(segment.dateStr));
                            });
                        } else {
                            dates = [Odigeo.Utils.parseDate(flightsData.searchSegments[0].dateStr),
                                Odigeo.Utils.parseDate(flightsData.searchSegments[numSegments - 1].dateStr)];
                        }
                        break;
                }
            }
            return this.template({
                legs: legs,
                type: constructorInfo.type,
                toLabel: constructorInfo.toLabel,
                dates: dates,
                passengers: constructorInfo.passengers,
                formatDate: Odigeo.Utils.formatDate,
                flexibleDates: constructorInfo.flexibleDates,
                differenceInDays: differenceInDays,
            });
        },

        expand: function() {
            $(this.view.$cachedSelectors['widgetWrapper']).removeClass('hidden');
        },

        collapse: function() {
            $(this.view.$cachedSelectors['widgetWrapper']).addClass('hidden');
        },

        repaint: function() {
            this.view.$el.find('.searchPanel_nonexpandible').addClass('hidden');
            this.view.$el.find('.searchPanel_expandible').removeClass('hidden');
        },

        toggleEditHeaderButtonHidden: function(hide) {
            this.view.toggleEditHeaderButtonHidden(hide);
        },

        _boldString: function(string) {
            return '<span class="od-searchPanel-bold">' + string + '</span>';
        },

        execute: function(fn) {
            var args = [].slice.call(arguments, 1);

            switch (fn) {
                case 'show':
                    this.view.showContent.apply(this.view, args);
                    break;
                case 'showDetailsInWaiting':
                    this.view.showDetailsInWaiting.apply(this.view, args);
                    break;
                case 'removeWaitingFlag':
                    this.view.removeWaitingFlag.apply(this.view, args);
                    break;
                case 'hide':
                    this.view.hideContent.apply(this.view, args);
                    break;
                case 'refresh':
                    this.refresh.apply(this, args);
                    break;
                case 'repaint':
                    this.repaint.apply(this, args);
                    break;
                case 'toggleEditHeaderButtonHidden':
                    this.toggleEditHeaderButtonHidden.apply(this, args);
                    break;
                case 'updateDate':
                    this.updateDate.apply(this, args);
                    break;
                case 'refreshAndShow':
                    this.refresh.apply(this, args);
                    this.view.showContent.apply(this.view, args);
                    break;
                case 'toggleFlightInfoPageButtonVisibility':
                    this.view.toggleFlightInfoPageButtonVisibility.apply(this.view, args);
                    break;
                case 'updateDetailsButtonDisplay':
                    this.view.updateDetailsButtonDisplay.apply(this.view, args);
                    break;
            }
            return this;
        },

        updateDate: function(date) {
            this.view.$el.find('.flight_date').html(date);
        },
    }));
